// Authentication-related constants and enums following our coding standards

/**
 * Social media providers supported for authentication
 * Using const enum for compile-time optimization and performance
 */
export const enum SocialAuthProvider {
  GOOGLE = 'google',
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube'
}

/**
 * Authentication UI constants
 * Using const assertion for type safety and performance
 */
export const AUTH_UI_CONSTANTS = {
  BUTTON_TEXT: {
    GOOGLE: 'Continue with Google',
    LINKEDIN: 'Continue with LinkedIn', 
    FACEBOOK: 'Continue with Facebook',
    INSTAGRAM: 'Continue with Instagram'
  },
  PROVIDER_NAMES: {
    GOOGLE: 'Google',
    LINKEDIN: 'LinkedIn',
    FACEBOOK: 'Facebook', 
    INSTAGRAM: 'Instagram'
  },
  CSS_CLASSES: {
    LINKEDIN_ICON: 'text-[#0077B5] size-5',
    FACEBOOK_ICON: 'text-[#1877F2] size-5',
    GOOGLE_ICON: 'size-6',
    PRIMARY_BUTTON: 'w-full flex h-[56px] rounded-xl text-white text-lg font-medium',
    SOCIAL_GRID: 'grid grid-cols-3 items-center w-full gap-3 self-stretch mb-4'
  },
  DEFAULT_PROVIDER: SocialAuthProvider.LINKEDIN
} as const;

/**
 * Authentication status enums for user onboarding flow
 */
export const enum AuthStatus {
  PENDING = 'pending',
  APPROVED = 'approved', 
  REJECTED = 'rejected',
  PENDING_REVIEW = 'pending_review'
}

/**
 * Login page layout constants
 */
export const LOGIN_LAYOUT_CONSTANTS = {
  IMAGE_AREA_HEIGHT: '70vh',
  CONTENT_PADDING: 'px-5 mt-4',
  TITLE_TEXT: 'Sign Up',
  SUBTITLE_TEXT: 'Sign up to continue'
} as const;

export type AuthUIConstants = typeof AUTH_UI_CONSTANTS;
export type LoginLayoutConstants = typeof LOGIN_LAYOUT_CONSTANTS;